import { RecoveryPasswordForm } from "@/components/auth/recovery-password-form"
export function RecoveryPasswordPage() {
  return <RecoveryPasswordForm />
}
